import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsAccentsPipe } from './utils-accents.pipe';

@NgModule({
  declarations: [UtilsAccentsPipe],
  exports: [UtilsAccentsPipe],
  imports: [CommonModule]
})
export class UtilsAccentsModule {}
